import { Modal } from "antd";
import { CSSProperties, ReactNode } from "react";
import "./Modal.scss";

interface ModalContainerType {
  showTopCancelButton?: boolean;
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
  modalHeader?: string;
  children: ReactNode;
  footer?: ReactNode;
  width?: string | number;
  showGradient?: boolean;
  variant?: "success" | "error" | "info";
  className?: string;
  maskStyle?: CSSProperties;
}

const ModalContainer = ({
  showTopCancelButton,
  showModal,
  setShowModal,
  modalHeader,
  children,
  footer,
  showGradient = false,
  width = 900,
  className = "",
  maskStyle,
  variant = "success",
}: ModalContainerType) => {
  const baseClasses =
    "w-full mx-auto h-[80px] absolute top-0 z-0 left-0 right-0  transition-colors duration-200 rounded-t-[20px]";
  const variantClasses = {
    success: "bg-green-gradient",
    error: "bg-red-gradient",
    info: "bg-yellow-gradient",
  };

  const classes = `
    ${baseClasses}
    ${variantClasses[variant]}
  `.trim().replace(/\s+/g, " ");

  return (
    <Modal
      className={`pt-10 !pb-10 overflow-hidden ${className}`}
      width={width}
      title={modalHeader}
      centered
      open={showModal}
      onCancel={() => setShowModal(false)}
      footer={false}
      closable ={showTopCancelButton}
      maskStyle={maskStyle}
    >
      <div className="content-container">
        {showGradient && <div className={classes}></div>}
        {children}
      </div>
    </Modal>
  );
};

export default ModalContainer;
